var _clipPath, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCovidcheckLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 106.9 93.5",
    viewBox: "0 0 106.9 93.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-36.4 0h179.1v174.1h-179.1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m57.2 62.5-12.3.1-9.9-24.3 10.4-.8 5.4 13.1 8.9-26.9 10.5.7z",
    fill: "#6decb3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231e49"
  }, /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m53.2 0-1 3.1h-3.2l2.6 1.8-1 3.1 2.6-1.9 2.6 1.9-1-3.1 2.6-1.8h-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m36 10.1 2.6-1.9h-3.3l-1-3.1-.9 3.1h-3.3l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m22.1 23.7 2.6-1.9h-3.3l-.9-3.1-1 3.1h-3.3l2.6 1.9-.9 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m16.8 43 2.6-1.9h-3.3l-.9-3.1-1 3.1h-3.2l2.5 1.9-.9 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m22.3 61.6 2.6-1.8h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.8-1 3.1 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m35.7 75.3 2.6-1.9h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m54.8 81 2.6-1.9h-3.2l-1-3-1 3h-3.2l2.6 1.9-1 3.1 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m73.9 75.3 2.6-1.9h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m87.3 61.6 2.6-1.8h-3.3l-1-3.1-.9 3.1h-3.3l2.6 1.8-1 3.1 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m92.8 43 2.6-1.9h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m87.5 23.7 2.6-1.9h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "m73.6 10.1 2.6-1.9h-3.2l-1-3.1-1 3.1h-3.2l2.6 1.9-1 3 2.6-1.9 2.6 1.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovidcheckLogo);
export default __webpack_public_path__ + "static/media/covidcheck_logo.0ec11800b0930bcadf294d3e328f0d58.svg";
export { ForwardRef as ReactComponent };